export const CREATE_EMPLOYEE_CATEGORY = 'common@create-employee-category';
export const CREATE_AND_UPDATE_EMPLOYEE_CATEGORY = 'common@create-and-update-employee-category';
export const DELETE_EMPLOYEE_CATEGORY = 'common@delete-employee-category';
export const UPDATE_EMPLOYEE_CATEGORY = 'common@update-employee-category';

